import React from 'react';
import _, { isString } from 'lodash';
import { ResponsiveLineCanvas } from '@nivo/line';
import { ChartProp } from '../../enum/apiResultProp/ChartProp';
import { Segment } from 'semantic-ui-react';

export default ({ chartProps }) => {
    const data = chartProps[ChartProp.Data];
    const curve = chartProps[ChartProp.Curve];
    const enableArea = chartProps[ChartProp.EnableArea];
    const enablePointLabel = chartProps[ChartProp.EnablePointLabel];
    const useMesh = chartProps[ChartProp.UseMesh];
    const hasLegend = chartProps[ChartProp.HasLegend];
    const bottomAxisLabel = chartProps[ChartProp.BottomAxisLabel];
    const leftAxisLabel = chartProps[ChartProp.LeftAxisLabel];

    let lineChartProps = {
        data: data,
        curve: curve,
        enableArea: enableArea,
        useMesh: useMesh
    };

    const colorSet = [
        '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf',
        '#ff1493', '#20b2aa', '#f39c12', '#e74c3c', '#3498db', '#2ecc71', '#9b59b6', '#16a085', '#f1c40f', '#8e44ad'
    ];

    let legends = [];
    let margin = { top: 50, right: 50, bottom: 50, left: 50 };
    if (hasLegend) {
        margin = { top: 50, right: 150, bottom: 50, left: 50 };
        legends = [
            {
                anchor: 'bottom-right',
                direction: 'column',
                translateX: 25,
                translateY: 0,
                itemsSpacing: 0,
                itemDirection: 'left-to-right',
                itemWidth: 0,
                itemHeight: 20,
                itemOpacity: 0.75,
                symbolSize: 15,
                symbolShape: 'circle',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemBackground: 'rgba(0, 0, 0, .03)',
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ]
    }

    const customTooltip = ({ point }) => (
        <Segment>
            <div
                style={{
                    width: "12px",
                    height: "12px",
                    marginRight: "8px",
                    display: "inline-block",
                    backgroundColor: point.serieColor,
                }}
            />
            {point.data.customXLabel}
            {point.data.customYLabel}
        </Segment>
    );

    if (bottomAxisLabel) {
        lineChartProps = { ...lineChartProps, axisBottom: { legend: bottomAxisLabel, legendOffset: 40, legendPosition: 'middle' } };
    }

    if (leftAxisLabel) {
        lineChartProps = { ...lineChartProps, axisLeft: { legend: leftAxisLabel, legendOffset: -40, legendPosition: 'middle' } };
    }

    let customLabelsLayer = null;
    if (enablePointLabel) {
        customLabelsLayer = ({ points, ctx }) => {
            ctx.font = '12px';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';
            ctx.fillStyle = '#000000ff';

            points.forEach(point => {
                const label = point.data.yFormatted ?? point.data.y;
                ctx.fillText(label, point.x, point.y - 15);
            });
        };
    }

    return (
        <div style={{ height: 500 }}>
            <ResponsiveLineCanvas
                {...lineChartProps}
                colors={colorSet}
                tooltip={customTooltip}

                margin={margin}
                pixelRatio={1.5}
                pointSize={10}

                layers={[
                    'grid',
                    'axes',
                    'areas',
                    'lines',
                    'points',
                    customLabelsLayer,
                    'mesh',
                    'legends'
                ]}

                legends={legends}
            />
        </div>
    );
}
